
import "@sparta.global.utilities/sparta-sticky-utility/dist/styles.css"
import "@sparta.global.utilities/sparta-widget-loader-utility/dist/styles.css"
import "@sparta.global.utilities/sparta-squeezebox-utility/dist/styles.css"
import "@sparta.global.utilities/sparta-footnote-utility/dist/styles.css"
import "@sparta.global-gt.modules/global-nav-module/dist/styles.css"
import "@sparta.global-gt.modules/search-stub-module/dist/styles.css"
import "@sparta.global.modules/title-module/dist/styles.css"
import "@sparta.company.modules/patent-intro-module/dist/styles.css"
import "@sparta.company.modules/patent-list-module/dist/styles.css"
import "@sparta.global-gt.modules/global-footer-module/dist/styles.css"
import "@sparta.global.modules/global-social-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"

import "@sparta.global.modules/semantic-markup-module/dist/es6.js"
import "@sparta.global-gt.modules/global-nav-module/dist/es6.js"
import "@sparta.global-gt.modules/search-stub-module/dist/es6.js"
import "@sparta.global.modules/title-module/dist/es6.js"
import "@sparta.company.modules/patent-intro-module/dist/es6.js"
import "@sparta.company.modules/patent-list-module/dist/es6.js"
import "@sparta.global-gt.modules/global-footer-module/dist/es6.js"
import "@sparta.global.modules/global-social-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}


// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
  console.log('after - execute boot functions')
})();
